import { useEffect } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';
import { useParams } from 'js/lib/useRouter';

import useCourseBySlug from 'bundles/course-v2/hooks/useCourseBySlug';
import loadCourseBySlug from 'bundles/course-v2/utils/loadCourseBySlug';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';

export const useLoadCourseBySlug = () => {
  const { courseId, courseIdsLoading } = useFluxibleStore(CourseStore, (store) => ({
    courseIdsLoading: !store.haveCourseIdentifiersLoaded(),
    courseId: store.getCourseId(),
  }));

  const courseSlug = useParams().courseSlug || '';
  const { courseData, loading: courseLoading, error } = useCourseBySlug(courseSlug);

  const executeAction = useFluxibleAction();

  useEffect(() => {
    if (!courseLoading && courseData) {
      executeAction(loadCourseBySlug, { courseSlug, course: courseData });
    }
  }, [courseLoading, courseData, executeAction, courseSlug]);

  return {
    loading: courseLoading || courseIdsLoading,
    error,
    courseId,
  };
};
